import React from "react";
import "./MailInputs.css";
import {FormattedMessage, useIntl} from "react-intl";
import {GroupMemberRequest} from "../../../logic/APITypes";
import {TextInput} from "@spg/component_library";
import {splitEmails} from "../../../logic/splitEmails";
import trash from "../../../resources/icons/trash.svg";
import plus from "../../../resources/icons/plus.svg";

type GroupMailInputsProps = {
  invitations: {
    get: GroupMemberRequest[];
    set: React.Dispatch<React.SetStateAction<GroupMemberRequest[]>>;
  };
  /** Hides a checkbox that would allow users to specify whether an email is to be added as an admin */
  adminsOnly: boolean;
  disabled?: boolean;
};

/** A part of a form allowing arbitrarily many emails to be entered */
function GroupMailInputs({
  invitations,
  adminsOnly,
  disabled,
}: GroupMailInputsProps) {
  const {formatMessage} = useIntl();

  return (
    <div className="groupMailInputs">
      <p>
        <FormattedMessage
          id="groupMailInputs.paragraph"
          values={{br: () => <br />}}
        />
      </p>
      {invitations.get.map((entry, i) => (
        <div key={"groupMailInput" + i} className="groupMailInputs__entry">
          <TextInput
            label={formatMessage({id: "groupMailInputs.input.mail"})}
            id={"groupMailInputsEmail" + i}
            value={entry.email}
            onChange={(e) =>
              invitations.set((old) => {
                const newAdmins = [...old];
                newAdmins[i].email = e.target.value;
                return newAdmins;
              })
            }
            type="email"
            disabled={disabled}
            onPaste={(e) => {
              const pasted = e.clipboardData.getData("text");
              const emails = splitEmails(pasted);
              if (emails.length > 1) {
                e.preventDefault();
                invitations.set((old) => {
                  const insertAt = old[i].email !== "" ? i + 1 : i;
                  return [
                    ...old.slice(0, insertAt),
                    ...emails.map((email) => ({
                      email,
                      is_admin: old[i].is_admin,
                    })),
                    ...old.slice(insertAt).filter((v) => v.email !== ""),
                  ];
                });
              }
            }}
          />
          {!adminsOnly && (
            <label className="groupMailInputs__checkbox">
              <input
                type="checkbox"
                checked={entry.is_admin}
                disabled={disabled}
                onChange={(e) =>
                  invitations.set((old) => {
                    const newAdmins = [...old];
                    newAdmins[i].is_admin = e.target.checked;
                    return newAdmins;
                  })
                }
              />
              <FormattedMessage id="groupMailInputs.input.admin" />
            </label>
          )}
          {invitations.get.length > 1 && (
            <button
              className="iconButton"
              onClick={() =>
                invitations.set((old) => [
                  ...old.slice(0, i),
                  ...old.slice(i + 1),
                ])
              }
              disabled={disabled}
            >
              <img
                src={trash}
                alt={formatMessage({
                  id: "groupMailInputs.button.delete",
                })}
                height={24}
              />
            </button>
          )}
        </div>
      ))}
      <button
        className="iconButton"
        onClick={() =>
          invitations.set((old) => [...old, {email: "", is_admin: false}])
        }
        disabled={disabled}
      >
        <img
          src={plus}
          alt={formatMessage({
            id: "groupMailInputs.button.add",
          })}
          height={24}
        />
      </button>
    </div>
  );
}

export default GroupMailInputs;
